import React from 'react';
import { forwardRef, useImperativeHandle, useState } from 'react';

import { Row, Col, Form, Input } from 'reactstrap';
import { Field, useFormikContext } from 'formik';
import { useHistory } from "react-router-dom";
import { toast } from 'react-toastify';
import Dropzone from 'react-dropzone-uploader';

import axios from 'axios';
import moment from 'moment';

const AdditionalDetails = forwardRef(({ formikRef, accessEnv }, ref) => {

  const history = useHistory();
  const { values } = useFormikContext()
  const environment = localStorage.getItem("environment");

  const [buttonLoading, setButtonLoading] = useState(false);

  const [attachmentIds, setAttachmentIds] = useState([]);

  const getUploadParams = ({ meta }) => { return { url: 'https://httpbin.org/post' } }


  const handleChangeStatus = ({ meta, file }, status) => {
    if (status == 'done') {
      uploadFile(file)
    }
    if (status == 'removed') {
      setAttachmentIds([])
    }
  }

  const uploadFile = (file) => {
    let fd = new FormData();
    fd.append('file', file)
    axios.post(`/api/v1/new_attachments`, fd, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(res => {
      let tempIds = [res.data.attachment.id]
      setAttachmentIds(tempIds)
      toast.success(res.data.message)
    }).catch(err => {
      toast.error(err.response.data.message)
    })
  }

  useImperativeHandle(ref, () => ({
    isValidated() {
      return true
    }
  }));

  const handleDataSubmit = () => {
    console.log(values)
    setButtonLoading(true);
    let freq = values?.frequency
    let freqObj = {}
    if (freq == 'weekly') {
      freqObj = { "days": values?.weekly }
    }
    else if (freq == 'other') {
      freqObj = { "other_details": values?.details }
    }
    else if (freq == 'monthly') {
      freqObj = { "date": moment(values?.monthly || new Date()).format("MM/DD/YYYY") }
    }
    let new_urls = []
    var rss_urls = accessEnv.includes(environment) ? new RegExp(/^\d+$/) : new RegExp(/.*/)
    new_urls = values?.site_details.filter(site => site?.url?.length > 0 && rss_urls.test(site?.rss_urls_crawl_limit))
    let inputData = {
      "submit_requirements": {
        "organization_name": values?.organization_name,
        "industry": values?.industry,
        "country": values?.country,
        "sitegroup_name": values?.sitegroup_name,
        "frequency": values?.frequency,
        "data_delivery": values?.data_delivery,
        "data_format": values?.data_format,
        "crawl_type": values?.crawl_type,
        "additional_information": values?.additional_information,
        "attachment_ids": attachmentIds,
        "schema_fields_details": values?.schema_fields_details,
        "rss_urls_crawl_limit": values?.rss_urls_crawl_limit,
        "additional_details": { 
          "merge_files": values?.merge_files ? 1 : 0, 
          "image_downloads": values?.image_downloads ? 1 : 0 
        },
        "delivery_frequency_details": freqObj,
        "site_details": new_urls
      }
    }

    axios.post(`/api/v1/organizations/create`, inputData)
    .then(res => {
      const data = res.data
      if (data.status == 'success') {
        toast.success(data.message)
        // A deep link saved before login (e.g. opened while unauthenticated)
        // survives sign-in's onboarding branch in sessionStorage. Now that the
        // user has an organization, send them back to where they intended to go.
        const redirectUrl = sessionStorage.getItem('redirectUrl')
        if (redirectUrl) {
          sessionStorage.removeItem('redirectUrl')
          window.location = redirectUrl
        } else {
          history.push(`/`)
        }
      }
      else {
        toast.error(data.message)
      }
      setButtonLoading(false);
    }).catch(err => {
      setButtonLoading(false);
      toast.error(err.response.data.message)
    })

  }

  const handleSubmit = (files, allFiles) => {
    allFiles.forEach(f => f.remove())
    toast.success("Dropzone successfully submitted !");
  }

  
  return(
    <div className='pt-3'>
      <section className='mb-4'>
        <h6 className='fw-bold mb-1'>Additional Information</h6>
        <p className='text-muted text-sm mb-3'>
          Anything else we should know about your requirements? Pagination behavior, login walls, specific date ranges, etc.
        </p>
        <Field
          as="textarea"
          rows={5}
          name="additional_information"
          id="description"
          className="form-control"
          placeholder='Describe any special requirements or constraints…'
        />
      </section>

      <hr className='my-4' />

      <section className='mb-4'>
        <h6 className='fw-bold mb-1'>Add-on Features</h6>
        <p className='text-muted text-sm mb-3'>
          Optional extras. Pricing impact will be reflected in the feasibility report.
        </p>
        <Row>
          <Col md={6}>
            <div className='form-check mb-2'>
              <Field
                id="merge_files"
                name="merge_files"
                type="checkbox"
                as={Input}
                className='form-check-input'
              />
              <label htmlFor='merge_files' className='form-check-label ms-1'>Enable Merge</label>
              <p className='text-muted text-sm m-0'>Combine output files from all sites in the sitegroup into a single delivery.</p>
            </div>
          </Col>
          <Col md={6}>
            <div className='form-check mb-2'>
              <Field
                id="image_downloads"
                name="image_downloads"
                type="checkbox"
                as={Input}
                className='form-check-input'
              />
              <label htmlFor='image_downloads' className='form-check-label ms-1'>Enable Image / File Downloads</label>
              <p className='text-muted text-sm m-0'>Download images and binary files referenced on the pages.</p>
            </div>
          </Col>
        </Row>
      </section>

      <hr className='my-4' />

      <section>
        <h6 className='fw-bold mb-1'>Attach a Reference File</h6>
        <p className='text-muted text-sm mb-3'>
          Optional &mdash; mockup of expected output, screenshot of the target data, or any reference document (max 14 MB).
        </p>
        <Form onSubmit={handleSubmit}>
          <div className="dz-message needsclick">
            <Dropzone
              getUploadParams={getUploadParams}
              maxFiles={1}
              onChangeStatus={handleChangeStatus}
              multiple={false}
              canCancel={true}
              inputContent="Browse / Drop a File"
              styles={{
                dropzone: { height: 70 },
                dropzoneActive: { borderColor: 'green' },
              }}
              maxSizeBytes={14680064}
            />
          </div>
        </Form>
      </section>

      <div className='d-flex justify-content-end mt-4 pt-3 border-top'>
        <button
          className='btn btn-success'
          type="button"
          disabled={buttonLoading}
          onClick={() => handleDataSubmit()}
        >
          {buttonLoading ? 'Submitting…' : 'Send for Final Feasibility Check'}
        </button>
      </div>
    </div>
  )

})

export default AdditionalDetails;
